import { APP_PREFIX_PATH } from 'configs/AppConfig'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Navigate, Outlet } from 'react-router-dom'

const PublicRoute = () => {
  const { token } = useSelector((state) => state.auth)
  const location = useLocation()
  const from = location.state?.from || APP_PREFIX_PATH

  return token ? <Navigate to={from} replace /> : <Outlet />
}

export default PublicRoute
